import * as React from 'react';
import { Link as LinkComponent } from '../Link/Link';
import { LinkVariant } from '../Link/LinkVariant.csharp';
import type { Link } from './Link.csharp';
import type { ResearchPublicationViewModel } from './ResearchPublicationViewModel.csharp';

export const ResearchPublication: React.FC<React.PropsWithChildren<ResearchPublicationViewModel>> = props => {
    const {
        authors,
        yearPublished,
        title,
        referenceTitle,
        referenceEditors,
        publisherName,
        isArticle,
        forceNonItalicTitle,
        isbn,
        volume,
        issue,
        pages,
        links,
    } = props;

    const addDot = (text: string) => {
        if (text && ['.', '?', '!'].lastIndexOf(text[text.length - 1]) > -1) {
            return text;
        }

        return `${text}.`;
    };

    const getLinkDetails = (link: Link) => (
        <>
            {link.isTypeToShow && `${link.urlType}: `}
            <LinkComponent href={link.url} label={link.title} variant={LinkVariant.LightBlack} />{' '}
        </>
    );

    const publicationPages = pages && `${pages}. `;
    const publisher = publisherName && (isArticle ? <i>{addDot(publisherName)} </i> : `${addDot(publisherName)} `);
    const publicationTitle =
        referenceTitle || isArticle || forceNonItalicTitle ? `${addDot(title)} ` : <i>{addDot(title)} </i>;
    const publicationYearPublished = yearPublished && `(${yearPublished}). `;
    const publicationReferenceTitle = referenceTitle && <i>{`${addDot(referenceTitle)} `}</i>;
    const publicationReferenceEditors = referenceEditors && `I ${referenceEditors} `;
    const publicationLinks = links && links.map(x => getLinkDetails(x));
    const publicationIsbn = isbn && `${addDot(isbn)} `;
    const publicationVolume = volume && `${volume}`;
    const publicationIssue = issue && `(${issue})`;
    const volumeAndIssue = `${publicationVolume}${publicationIssue} `;

    return (
        <>
            {`${authors} `}
            {publicationYearPublished}
            {publicationTitle}
            {publicationReferenceEditors}
            {publicationReferenceTitle}
            {publisher}
            {publicationIsbn}
            {volumeAndIssue}
            {publicationPages}
            {publicationLinks}
        </>
    );
};
